<div class="modal-backdrop" (click)="onClose()"></div>
<div class="modal">
  <div class="modal-header">
    <h2>Transaction Details</h2>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <div class="modal-body">
    <div *ngIf="loading" class="loading-state" style="text-align:center; padding:40px;">
      <i class="fas fa-spinner fa-spin" style="font-size:2rem; color:#4f46e5;"></i>
      <p style="margin-top:12px; color:#666;">Fetching details...</p>
    </div>

    <div *ngIf="!loading && fullTransaction">
      <div class="transaction-section">
        <div class="transaction-header">
          <h3 title="Transaction ID">{{fullTransaction.gateway_payment_id || 'N/A'}}</h3>
          <span [class]="'badge ' + getStatusClass(fullTransaction.status)">
            {{fullTransaction.status | titlecase}}
          </span>
        </div>

        <div class="info-grid">
          <div class="info-item">
            <span class="label">Retailer:</span>
            <span class="value">{{fullTransaction.retailer_name || fullTransaction.to_entity_name || 'N/A'}}</span>
          </div>

          <div class="info-item" *ngIf="fullTransaction.invoice_no">
            <span class="label">Invoice Number:</span>
            <span class="value">{{fullTransaction.invoice_no}}</span>
          </div>

          <div class="info-item">
            <span class="label">Amount:</span>
            <span class="value amount">₹{{fullTransaction.amount | number}}</span>
          </div>

          <div class="info-item">
            <span class="label">Payment Method:</span>
            <span class="value">{{(fullTransaction.payment_method || fullTransaction.payment_mode) | titlecase}}</span>
          </div>

          <div class="info-item">
            <span class="label">Transaction ID:</span>
            <span class="value">{{fullTransaction.gateway_payment_id || fullTransaction.id || 'N/A'}}</span>
          </div>

          <div class="info-item">
            <span class="label">Transaction Date:</span>
            <span class="value">{{fullTransaction.created_at | date:'dd/MM/yyyy, h:mm a'}}</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!loading && !fullTransaction" class="error-state" style="text-align:center; padding:40px;">
      <p style="color:#ef4444;">Failed to load transaction details.</p>
    </div>
  </div>

  <div class="modal-footer">
    <button *ngIf="fullTransaction && fullTransaction.reference_id" type="button" class="btn-primary"
      (click)="downloadInvoice()" style="background:#4f46e5; color:#fff; border:none; padding:8px 16px; border-radius:4px; cursor:pointer; margin-right:auto;">
      <i class="fas fa-download"></i> Download Invoice
    </button>
    <button type="button" class="btn-secondary" (click)="onClose()"
      style="padding:8px 16px; border-radius:4px; border:1px solid #ddd; background:#fff; cursor:pointer;">
      Close
    </button>
  </div>
</div>